export default function ({ store }) {
  if (store.$auth.loggedIn && !store.getters['offline/isOffline']) {
    if(store.$auth.user.tipo === 'cliente') store.dispatch(`notificaciones/list`, { cliente: store.$auth.user.uuid })
    else store.dispatch(`notificaciones/list`)
  }
}
